<template>
  <ItemRow>
    <ItemWithLabel
      :column="columns[0]"
    >
      {{ itemData.version }}
    </ItemWithLabel>
    <ItemWithLabel
      :column="columns[1]"
    >
      <ButtonLink
        :text="usersCount"
        @click="handleUserCountClick"
      />
    </ItemWithLabel>
    <PasswordManagerUsersItemListModal
      v-if="showUsersModal"
      :defaultFilters="usersModalFilters"
      :excludedColumns="excludedUserColumns"
      :headerText="usersModalHeaderText"
      @closeUsersModal="handleCloseUsersModal"
    />
  </ItemRow>
</template>

<script>
import {
  ButtonLink,
  ItemRow,
  ItemWithLabel,
} from '@jumpcloud/ui-components';
import { passwordManagerOSLabels } from 'client/PasswordManager/PasswordManagerConstants';
import { columns as passwordManagerUsersItemListColumns } from 'client/PasswordManager/Users/PasswordManagerUsersItemListColumns';
import PasswordManagerFilters from 'client/PasswordManager/PasswordManagerFilters';
import PasswordManagerUsersItemListModal from 'client/PasswordManager/Users/PasswordManagerUsersItemListModal.vue';

export default {
  name: 'PasswordManagerAppVersionItemListRow',

  components: {
    ButtonLink,
    ItemRow,
    ItemWithLabel,
    PasswordManagerUsersItemListModal,
  },

  props: {
    columns: {
      type: Array,
      default: () => ([]),
    },

    itemData: {
      type: Object,
      required: true,
    },

    os: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      usersModalFilters: [],
      showUsersModal: false,
      usersModalHeaderText: '',
    };
  },

  computed: {
    excludedUserColumns() {
      return [passwordManagerUsersItemListColumns.actions,
        passwordManagerUsersItemListColumns.oldPasswords,
        passwordManagerUsersItemListColumns.weakPasswords];
    },

    usersCount() {
      return this.itemData.users_count?.toString();
    },
  },

  methods: {
    handleCloseUsersModal() {
      this.showUsersModal = false;
    },

    handleUserCountClick() {
      this.showUsersModal = true;
      this.usersModalHeaderText = `${passwordManagerOSLabels.find(({ os }) => os === this.os).label} Users on version ${this.itemData.version}`;
      this.usersModalFilters = [
        PasswordManagerFilters.operatingSystem(this.os),
        PasswordManagerFilters.appVersion(this.itemData.version),
        PasswordManagerFilters.activeUsers(1),
      ];
    },
  },
};
</script>
